import React, { useState } from 'react';
import vaseImage from '../assets/images/flowers/vase.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SpecialRewardPage: React.FC = () => {
  const { t } = useTranslation();
  const [showShareModal, setShowShareModal] = useState(false);
  const [emails, setEmails] = useState(['', '']);
  const [codeCopied, setCodeCopied] = useState(false);
  const rewardCode = "WELCOME50";
  const navigate = useNavigate();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(rewardCode);
    setCodeCopied(true);
    setTimeout(() => setCodeCopied(false), 2000);
  };

  const handleEmailChange = (index: number, value: string) => {
    const newEmails = [...emails];
    newEmails[index] = value;
    setEmails(newEmails);
  };

  const handleShareSubmit = () => {
    // Here you would implement the email sending logic
    console.log('Sending to emails:', emails);
    setShowShareModal(false);
    
    // Navigate to the reward subscription page
    navigate('/reward-subscription', {
      state: {
        rewardCode: rewardCode
      }
    });
  };

  return (
    <div className="min-h-screen bg-amber-100 flex flex-col items-center">
      <div className="w-full max-w-md px-4 mt-14 flex flex-col items-center">
        {/* Congratulations Header */}
        <div className="text-center mb-10">
          <h1 className="text-[42px] font-bold text-black mb-1">
            {t('specialReward.congratulations')}
          </h1>
          <p className="text-2xl text-black mb-2">
            {t('specialReward.welcomeGiftUnlocked')}
          </p>
          <div className="w-3/5 h-1 bg-amber-500 mx-auto relative overflow-visible">
            <div className="absolute -right-5 -top-0.5 w-5 h-3 bg-amber-500 rotate-12"></div>
          </div>
        </div>
        
        {/* 3D Platform Effect */}
        <div className="relative w-full mt-10 mb-14 flex justify-center">
          
          {/* Ticket Card */}
          <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl transform -rotate-3 w-5/6 max-w-sm">
            {/* Left side notch */}
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-4 h-10 bg-amber-100 rounded-r-full"></div>
            
            {/* Right side notch */}
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-4 h-10 bg-amber-100 rounded-l-full"></div>
            
            <div className="p-6">
              {/* Logo */}
              <div className="flex items-center mb-4">
                <div className="text-amber-500 font-bold flex items-center">
                  <span className="uppercase tracking-wider">{t('specialReward.piikaFlowers')}</span>
                </div>
              </div>
              
              {/* Main Content */}
              <div className="w-full">
                <div className="pr-1">
                  <h2 className="font-black leading-tight uppercase">
                    <span className="text-black text-2xl">{t('specialReward.freeDelivery')}</span>
                    <br />
                    <span className="text-black text-2xl">{t('specialReward.withVases')}</span>
                  </h2>
                  <p className="text-gray-700 text-sm my-2">
                    {t('specialReward.shareJoy')}
                  </p>
                  
                  <div className="border-t border-gray-200 w-full my-3"></div>
                  
                  {/* How To Use Section */}
                  <div className="mt-4 text-xs">
                    <div className="bg-amber-50 rounded-lg p-3">
                      <p className="font-medium text-black mb-2">{t('specialReward.howItWorks')}</p>
                      <div className="space-y-3">
                        {/* For You */}
                        <div>
                          <p className="font-medium text-amber-700">{t('specialReward.forYou')}</p>
                          <ol className="list-decimal pl-4 text-gray-600 mt-1">
                            <li>{t('specialReward.copyRewardCode')}</li>
                            <li>{t('specialReward.shareWithFriends')}</li>
                          </ol>
                        </div>
                        
                        {/* For Friends */}
                        <div>
                          <p className="font-medium text-amber-700">{t('specialReward.forYourFriends')}</p>
                          <ol className="list-decimal pl-4 text-gray-600 mt-1">
                            <li>{t('specialReward.enterCode')}</li>
                            <li>{t('specialReward.addAddress')}</li>
                            <li>{t('specialReward.selectVases')}</li>
                          </ol>
                        </div>
                      </div>
                      
                      <p className="mt-3 text-gray-500 border-t border-amber-200 pt-2">
                        <span className="font-medium">{t('specialReward.expires')}:</span> {t('specialReward.expirationDate')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Empty space to match reference */}
        <div className="flex-grow"></div>
        
        {/* CTA Button */}
        <div className="w-full mt-12 mb-6">
          <button 
            onClick={() => navigate('/reward-subscription', {
              state: {
                rewardCode: rewardCode
              }
            })}
            className="w-full bg-amber-500 text-white font-bold py-4 px-6 rounded-xl text-xl"
          >
            {t('specialReward.shareGift')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecialRewardPage; 